module.exports = __webpack_public_path__ + "virgina_lottery.png?f61a3ce8acd7aff883c3d9e2be357850";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/brands/virgina_lottery.png
// module id = 632
// module chunks = 0